export function contentPublicBaseUrl(): string {
  return import.meta.env.VITE_XQ_CONTENT_BASE_URL || "/xq_content/public";
}

export function contentBaseUrl(): string {
  return `${contentPublicBaseUrl()}/json`;
}

export function contentSoundsBaseUrl(): string {
  return `${contentPublicBaseUrl()}/sounds`;
}
